import request from "@/utils/request";
import { IEviSubject } from "../model/evisubject";

// 实体
export const defaultEviSubjectData: IEviSubject = {
  id: "",
  subjectType: -1,
  subjectName: "",
  memberId: "",
  creatorId: "",
  createTime: null,
  updateTime: null,
  updateId: "",
  isActive: false
};

export const getEviSubject = (id: any) => {
  request({
    url: "/EviSubject/Get",
    method: "post",
    params: { id: id }
  });
};

export const addEviSubject = (data: any) =>
  request({
    url: "/EviSubject/Add",
    method: "post",
    data
  });

export const updateEviSubject = (data: any) =>
  request({
    url: "/EviSubject/Update",
    method: "post",
    data
  });

export const deleteEviSubject = (id: string) =>
  request({
    url: "/EviSubject/Delete",
    method: "post",
    params: { id: id }
  });

export const getEviSubjectPageList = (data: any) =>
  request({
    url: "/EviSubject/GetPageListAsync",
    method: "post",
    data
  });

export const getEviSubjectArr = () =>
  request({
    url: "/EviSubject/GetEviSubjectArr",
    method: "post"
  });

export const getSubjectDigest = (id: string) =>
  request({
    url: "/EviSubject/GetSubjectDigest",
    method: "post",
    params: { id: id }
  });
